import { countries, CountryCode } from '@/i18n/countries';
import { Language } from '@/types/common';
import { CodeTitle } from '@/types/general';
import { CityS, CountryContainer, TranslationSource } from '@/types/platform-data';
import { apiBaseUrl } from '@/utils/constants';

import { ENTITIES } from './api.constant';

const fields$languages$base = (
    ['code', 'title', 'translations.nom', 'translations.language'] satisfies Array<
        keyof Language | `translations.${keyof Language['translations'][number]}`
    >
).join(',');

export async function languages$get$base(): Promise<CodeTitle[]> {
    const url = `${apiBaseUrl}${ENTITIES.languages}?fields=${fields$languages$base}&sort[]=title`;
    const response = await fetch(url, { next: { revalidate: 21_600 } }).then((res) => res.json());
    return response?.data ?? [];
}

const fields$translations = (['entity', 'language', 'nom', 'gen', 'loc'] satisfies Array<keyof TranslationSource>).join(
    ',',
);

export async function countries$get$translations(countryCode: CountryCode): Promise<TranslationSource<CountryCode>[]> {
    // const filter = encodeURIComponent(JSON.stringify({ entity: countryCode, language: { _in: languageCodes } }));
    const url = `${apiBaseUrl}${ENTITIES.countryTranslations}?fields=${fields$translations}`;
    const response = await fetch(url, { next: { revalidate: 21_600 } }).then((res) => res.json());
    return response?.data ?? [];
}

export async function cities$get$translations(countryCode: CountryCode, lang: string): Promise<TranslationSource[]> {
    const filter = encodeURIComponent(JSON.stringify({ entity: { country: countryCode }, language: { _eq: lang } }));
    const url = `${apiBaseUrl}${ENTITIES.cityTranslations}?fields=${fields$translations}&filter=${filter}`;

    const response = await fetch(url).then((res) => res.json());
    return response?.data ?? [];
}

const fields$cities$s = (['id', 'name', 'is_keyword'] satisfies Array<keyof CityS>).join(',');

export async function cities$get$s(countryCode: string): Promise<CityS[]> {
    const filter = encodeURIComponent(JSON.stringify({ country: countryCode }));
    const filterStr = countryCode !== 'RU' ? `&filter=${filter}` : '';
    const url = `${apiBaseUrl}${ENTITIES.cities}?fields=${fields$cities$s}${filterStr}&sort[]=name`;
    const response = await fetch(url).then((res) => res.json());
    return response?.data ?? [];
}

export async function getCountryConBySlug(
    countrySlug: string | undefined,
    lang?: string,
): Promise<CountryContainer | undefined> {
    const country = countries.find((country) => country.slug === countrySlug);
    if (!country) return;
    const cities = await cities$get$s(country.code);
    const countryTrans = await countries$get$translations(country.code);
    const citiesTrans = await cities$get$translations(country.code, lang ?? 'en');
    return { country: country, cities: cities, countryTranslations: countryTrans, citiesTranslations: citiesTrans };
}
